var Assessment = {

    editable : false,
    stars: 0,

    init:function() {
        Assessment.bindFrameworkSelect();
        Assessment.displayDummyGraphs();
        Assessment.enableMultiSelect();
        Assessment.bindFrameworkComplexSelect();
        Assessment.bindStatementSelect();
        Assessment.bindStarCard();
        Assessment.bindEditStarCard();
        Assessment.bindAssessmentSelects();
        Assessment.bindLevelEdit();
        Assessment.bindSetStatementNa();
        Assessment.bindClassAccordion();
        Assessment.bindLevelAccordion();
        /* double star card completion
        Assessment.bindSaveStarCard();
        Assessment.bindCompleteStatementsWithEvidence();
        */
        Assessment.bindShowBootstrapEvents();
        Assessment.bindToggleLevelModal();
        Assessment.bindToggleSubjectModal();
        Assessment.bindToggleFrameworkModal();
        Assessment.bindLevelPdf();
        Assessment.bindBaselineFramework();
        Assessment.bindBaselineTutorGroup();
        Assessment.bindStatementClick();
        Assessment.bindCompleteStatements();
        Assessment.bindEvidenceDateRange();
        Assessment.bindLevelDatePicker();
        Assessment.bindGroupStarComplete();
        Assessment.bindSetRandomStar();
        Assessment.bindUncompleteStar();
    },

    bindEvidenceDateRange: function () {
        $('.evidence-date-range').click(function() {
            $('#rangeInputs').slideToggle('fast');
        });
    },

    bindBaselineFramework: function() {
        $('#baselines-framework').change(function() {
            var frameworkId = $(this).val();
            var pupilId = $('#selectedPupil').data('id');

            if (typeof pupilId === 'undefined') {
                pupilId = $('#baseline-pupils > a:first').data('id');
            }

            window.location.href = '/baselines/' + pupilId + '/' + frameworkId;
        })
    },

    bindBaselineTutorGroup: function() {
        $('#baselines-tutor-group').change(function() {
            var frameworkId =  $('#baselines-framework').val();
            var tutorGroupId = $(this).val();
            var pupilId = $('#selectedPupil').data('id');

            window.location.href = '/baselines/undefined/' + frameworkId + '?tutorGroup=' + tutorGroupId;
        })
    },


    bindBaselineSelect: function() {
        $('#baselineSelect').on('change', function() {
            var year = $(this).val();
            var btn = $('#baselineBtn');
            var baseUrl = btn.data('url');
            btn.attr('href', baseUrl + '?year=' + year);
        });
    },

    bindClearLevel: function() {
        $('#clearLevelBtn').on('click', function() {
            var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
            $(this).html(html);
            $(this).prop('disabled', true);
        });
    },

    bindShowBootstrapEvents: function() {
        $('#starCardModal').on('shown.bs.modal', function () {
            //alert('shown.bs.modal');
        });
        $('#starCardModal').on('hidden.bs.modal', function () {
            //alert('hidden.bs.modal');
        });
    },

    bindSaveStarCard: function() {
        $('#starCardForm').on('change', function(event) {
            $('#starCardSave').removeAttr('disabled')
        });
        $('.starcard-input').on('keyup', function(event) {
            $('#starCardSave').removeAttr('disabled')
        });
        $('.star-card-file').on('click', function(event) {
            $('#starCardSave').removeAttr('disabled')
        });
        $('#starCardSave').on('click', function(event) {
            //event.preventDefault ? event.preventDefault() : (event.returnValue = false);
            //$('#backfillModal').modal();
            // var btn = $(this);
            var btn = $('#starCardSave');
            var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
            var form = $('#starCardForm');
            var data = form.serialize();
            var url = form.attr('action');
            var levelId = btn.data('level');
            var subjectId = btn.data('subject');
            var frameworkId = btn.data('framework');
            var pupilId = btn.data('pupil');

            if (btn.data('backfill') == 1 && btn.data('autobackfill') == 1 && $('#achieved').is(':checked')) {
                Assessment.bindAutoBackfillModalActions();
                return false;
            } else if (btn.data('backfill') == 1 && btn.data('autobackfill') == 0 && $('#achieved').is(':checked')) {
                $('#backfillModal').modal();
                return false;
            } else {

                btn.html(html);
                /* disable button in form's submit event
                btn.attr('disabled', true);
                */

                var modal = $('#starCardModal');
                //$.post(url, data, function() {
                // Assessment.ajaxLevelData(levelId, subjectId, frameworkId, pupilId);
                // modal.modal('hide');
                //location.reload();
                //});

                /* disable button in form's submit event
                form.submit();
                */
                form.submit(function () {
                    //btn.html(html);
                    //btn.attr('disabled', true);
                    $('#starCardSave').prop('disabled', true);
                });
            }
        })
    },

    bindCompleteStatementsWithEvidence: function() {
        $('#completeStatmentsWithEvidence').on('click', function(e) {
            e.stopPropagation();
            var btn = $(this);
            var levelId = btn.data('level');
            var subjectId = btn.data('subject');
            var frameworkId = btn.data('framework');
            var pupilId = btn.data('pupil');
            var form = $('#form-' + levelId);
            var url = form.attr('action');
            //var data = form.add($('#starCardForm')).serializeArray();
            form.append($('#starCardForm').find(':input:not(:hidden)').clone());

            //$.post(url, data, function() {
            //     Assessment.ajaxLevelData(levelId, subjectId, frameworkId, pupilId);
                //window.location.reload();
            //});
            form.submit();
        });
    },

    bindAutoBackfillModalActions: function() {
        var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
        var btn = $('#starCardSave');
        var form = $('#starCardForm');
        var url = form.attr('action');
        var modal = $('#starCardModal');
        var levelId = btn.data('level');
        var subjectId = btn.data('subject');
        var frameworkId = btn.data('framework');
        var pupilId = btn.data('pupil');


            url = url + '?backFill=1';

            var data = form.serialize();
            btn.html(html);
            btn.attr('disabled', true);

            //form.submit();
            $.post(url, data, function() {
                Assessment.ajaxLevelData(levelId, subjectId, frameworkId, pupilId);
                modal.modal('hide');
                //location.reload();
            });
    },


    bindBackfillModalActions: function() {
        var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
        var btn = $('#starCardSave');
        var form = $('#starCardForm');
        var url = form.attr('action');
        var modal = $('#backfillModal');
        var levelId = btn.data('level');
        var subjectId = btn.data('subject');
        var frameworkId = btn.data('framework');
        var pupilId = btn.data('pupil');

        $('.backfillAction').off('click').on('click', function(e) {
            e.preventDefault();
            var form = $('#starCardForm');
            var url = form.attr('action');
            if ($(this).attr('id') == 'backfillYes') {
                url = url + '?backFill=1';
            }

            var data = form.serialize();
            btn.html(html);
            btn.attr('disabled', true);

            //form.submit();
            $.post(url, data, function() {
                Assessment.ajaxLevelData(levelId, subjectId, frameworkId, pupilId);
                modal.modal('hide');
                //location.reload();
            });
            modal.modal('hide');
            return false;
        });

        $('#backfillCancel').click(function() {
            //modal.modal('hide');
            $('#backfillModal').modal('hide');
            return false;
        });
    },


    bindToggleLevelModal: function() {
        $('.level-modal').on('click', function(e) {
            e.stopPropagation();
            var levelId = $(this).data('levelid');
            var addAction = '/' + levelId;
            var evidenceForm = $("#evidenceForm");
            var action = evidenceForm.attr('action');
            var pieces = action.split('\/');
            var newAction = '/evidence';
            for (var i = 2; i < 5; i++) {
                newAction += '/' + pieces[i];
            }
            newAction += addAction;
            evidenceForm.attr("action", newAction);
            var modal = $('#evidenceModal');
            modal.modal();
        });
    },

    bindToggleSubjectModal: function() {
        $('.subject-modal').on('click', function(e) {
            e.stopPropagation();
            var evidenceForm = $("#evidenceForm");
            var action = evidenceForm.attr('action');
            var pieces = action.split('\/');
            var newAction = '/evidence';
            for (var i = 2; i < 5; i++) {
                newAction += '/' + pieces[i];
            }
            evidenceForm.attr("action", newAction);
            var modal = $('#evidenceModal');
            modal.modal();
        });
    },

    bindToggleFrameworkModal: function() {
        $('.framework-modal').on('click', function(e) {
            e.stopPropagation();
            var evidenceForm = $("#evidenceForm");
            var frameworkId = $(this).data('frameworkid');
            var action = evidenceForm.attr('action');
            var pieces = action.split('\/');
            var newAction = '/evidence';
            for (var i = 2; i < 4; i++) {
                if (i !== 3) {
                    newAction += '/' + pieces[i];
                } else {
                    newAction += '/' + frameworkId;
                }
            }
            evidenceForm.attr("action", newAction);
            var modal = $('#evidenceModal');
            modal.modal();
        });
    },

    /**
     * Bind framework selects
     */
    bindFrameworkSelect: function() {
        $('#soladmin-select-framework').change(function(e) {
            window.location.href = '/soladmin/frameworks/' + $(this).val() + '/edit#setup';
        });

        $('#admin-select-framework').change(function(e) {
            window.location.href = '/admin/frameworks/' + $(this).val() + '/edit#setup';
        });
    },

    bindClassAccordion: function() {
        $('.class-accordion').click(function() {
            var extraPupils = $(this).data('extra');
            var classId = $(this).data('class');
            var extraQueryString = '';
            if (extraPupils == 1) {
                extraQueryString = '&extra=1';
            }
            $.get('/class/' + classId + '?subject=' + $(this).data('subject') + '&term=' + $(this).data('term') + extraQueryString, function(data){
                $('#class-' + classId).html(data);
            });
        });
    },

    bindLevelAccordion: function() {
        $('.level-accordion').click(function() {
            // if spiky profile pupil use sticky level
            var newURL = location.href.split("?")[0];
            window.history.pushState('object', document.title, newURL);
            $('#star-card-list').find('small').each(function() {
                if ($(this).text() == 'STICKY') {
                    $(this).text('');
                }
            });
            var accordion = $(this);
            var levelId = accordion.data('level');
            var levelContainer = $('#level-' + levelId);
            if (levelContainer.children().length < 1) {
                var loadingDiv = '<div class="loader-container"><div class="cssload-loader"></div></div>';
                var subjectId = $(this).data('subject');
                var frameworkId = $(this).data('framework');
                var pupilId = $(this).data('pupil');
                accordion.prepend(loadingDiv);
                Assessment.ajaxLevelData(levelId, subjectId, frameworkId, pupilId);
            }
        });
    },

    ajaxLevelData: function(levelId, subjectId, frameworkId, pupilId) {
        $.get('/level/' + levelId + '?subject=' + subjectId + '&framework=' + frameworkId + '&pupil=' + pupilId, function(data){
            var levelDataContainer = $('#level-' + levelId);
            var accordion = $('#accordion-' + levelId);
            levelDataContainer.html(data);
            accordion.find('.loader-container').remove();
            Assessment.bindRestoreStatementNa();
            Assessment.bindSetStatementNa();
            Assessment.bindStatementClick();
            Assessment.bindSetRandomStar();
            $('#starCardModal').modal('hide');
        });
    },

    bindSetRandomStar: function() {
        $('.star-not-completed').contextmenu(function(event) {
            //event.stopPropagation();
            var levelId = $(this).data('level-id');
            var statementId = $(this).data('statement-id');
            var statementInput = $('#statement-' + statementId);
            var container = $('#completeStatementContainer-' + levelId);
            var datePicker = $('#datePicker-' + levelId);
            var btn = $('.statement-number[data-statement="' + statementId + '"]');

            var starTd = $(this).closest('td');
            var randomStars = false;
            starTd.siblings('td').each(function() {
                if ($(this).children('.random-star').length) {
                    randomStars = true;
                    return;
                };
            });

            var starId = $(this).data('star-id');
            if (!$(this).hasClass('random-star')) {
                $(this).addClass('random-star')
                    .css('color', '#90EE90');
                btn.addClass('selected-statement').addClass('selected-statement-' + levelId);
                container.find('a:first').text('Complete Stars');
                container.show();
                datePicker.removeClass('hidden').addClass('display-inline');
                statementInput.prop('checked', true);
                $(this).append('' +
                    '<input id="random-star-' + statementId + '-' + starId +
                    '" name="random_star_ids[' + statementId + '][]" value=' + starId + ' style="display:none;">'
                );
                var pupilId = $(this).data('pupil-id');
                var frameworkId = $(this).data('framework-id');
                var subjectId = $(this).data('subject-id');
                Assessment.prepAddEvidenceBtn(levelId, statementId, starId);
            } else {
                $(this).removeClass('random-star')
                    .css('color', '#e3e3e3');
                $('#random-star-'  + statementId + '-' + starId).remove();
                if (!randomStars) {
                    if (btn.hasClass('selected-statement')) {
                        btn.removeClass('selected-statement').removeClass('selected-statement-' + levelId);
                        if ($('.selected-statement-' + levelId).length == 0) {
                            container.hide();
                            container.find('a:first').text('Complete Statements');
                            datePicker.addClass('hidden').removeClass('display-inline');
                        }
                        statementInput.prop('checked', false);
                    }
                }
            }
            return false;
        });
    },

    prepAddEvidenceBtn: function(levelId, statementId, starId) {
        var addEvidenceBtn = $('#addEvidence-' + levelId);
        if (addEvidenceBtn.data('statement-id')) {
            addEvidenceBtn.removeAttr('data-statement-id');
        }
        addEvidenceBtn.attr('data-statement-id', statementId);
        if (addEvidenceBtn.data('star-id')) {
            addEvidenceBtn.removeAttr('data-star-id');
        }
        addEvidenceBtn.attr('data-star-id', starId);
        if (addEvidenceBtn.data('star-card-id')) {
            addEvidenceBtn.removeAttr('data-star-card-id');
        }
        addEvidenceBtn.attr('data-star-card-id', 'add');
        if (addEvidenceBtn.data('multievidence')) {
            addEvidenceBtn.removeAttr('data-multievidence');
        }
        addEvidenceBtn.attr('data-multievidence', 'yes');
        // add Add Evidence Button if hidden in group star complete
        $('.add-evidence').show();
    },

    bindUncompleteStar: function() {
        //$('.fa-star.hover-zoom-large:not(.star-not-completed)').contextmenu(function() {
        $('.uncomplete-stars').contextmenu(function () {
            var button = $(this);
            var starCardId = button.data('star-card-id');
            var levelId = button.data('level-id');

            if (button.hasClass('uncomplete-stars')) {
                url = '/assessment/star-cards/uncomplete/' + starCardId;
            } else {
                if (button.hasClass('star-not-completed')) {
                    url = '/assessment/star-cards/complete/' + starCardId;
                }
            }

            $.post(url, function (data, status, xhr) {
            }, 'json').done(levelId, function (data) {
                if (button.hasClass('uncomplete-stars')) {
                    button.css('color', '#e3e3e3');
                    button.removeClass('uncomplete-stars').addClass('star-not-completed');
                    $('#uncomplete-refresh-' + levelId).show();
                } else {
                    if (button.hasClass('star-not-completed')) {
                        button.css('color', data['colour']);
                        button.removeClass('star-not-completed').addClass('uncomplete-stars');
                    }
                }
            }).fail(function (jqxhr, settings, ex) {
                alert('failed, ' + ex);
            });

            return false;
        });
    },

    bindStatementClick: function() {
        $('.statement-number').click(function(e) {
            var btn = $(this);
            var levelId = btn.data('level');
            var statementId = btn.data('statement');
            var statementInput = $('#statement-' + statementId);
            var container = $('#completeStatementContainer-' + levelId);
            var datePicker = $('#datePicker-' + levelId);

            if (btn.hasClass('selected-statement')) {
                btn.removeClass('selected-statement').removeClass('selected-statement-' + levelId);
                if ($('.selected-statement-' + levelId).length == 0) {
                    container.hide();
                    datePicker.addClass('hidden').removeClass('display-inline');
                }
                statementInput.prop('checked', false);
                return false;
            }

            btn.addClass('selected-statement').addClass('selected-statement-' + levelId);
            container.show();
            datePicker.removeClass('hidden').addClass('display-inline');
            statementInput.prop('checked', true);
            Assessment.prepAddEvidenceBtn(levelId, statementId, 0);
        });
    },

    bindCompleteStatements: function() {
        $('.complete-statements').click(function(e) {
            e.stopPropagation();
            var btn = $(this);
            var levelId = btn.data('level');
            var subjectId = btn.data('subject');
            var frameworkId = btn.data('framework');
            var pupilId = btn.data('pupil');
            var form = $('#form-' + levelId);
            var url = form.attr('action');
            //var data = form.serialize();

            // $.post(url, data, function() {
            //     Assessment.ajaxLevelData(levelId, subjectId, frameworkId, pupilId);
            // });
            form.submit();
        })
    },

    bindLevelDatePicker: function() {
        $('.level-datepicker').click(function(e) {
           e.stopPropagation();
        });

        $('.level-datepicker').change(function() {
            var input = $(this);
            var levelId = input.data('level');
            var actualInput = $('#dateInput-' + levelId);
            var val = input.val();
            actualInput.val(val);
        });
    },

    // bindSendEmail: function() {
    //     $('#starcard-email-send').click(function() {
    //         var emailBtn = $(this);
    //         var pageData = $($('.modal-content')[0]).html();
    //         var data = {
    //           'pageData': pageData
    //         };
    //
    //         var email = $('#starcard-email-address').val();
    //         $.post('/assessment/star-cards/' + emailBtn.data('starCardId') + '/print?email=' + email, data ,function(res) {
    //             if (res.success) {
    //                 alert('Email sent successfully.');
    //             }
    //         });
    //
    //         // $.get('/assessment/star-cards/' + emailBtn.data('starCardId') + '/print?pdf=true', function(data) {
    //         //     alert('success');
    //         // });
    //     })
    // },

    bindCompletedDatePicker: function() {
        $('#completed-date').datepicker({
            format: 'D d MM yyyy',
            autoclose: true,
            todayBtn: 'linked', // Show a 'Today' button at the bottom, selecting it selects the current date
            weekStart: 1 // Start weeks on Monday,
        });
    },

    /**
     * Bind statement selects
     */
    bindStatementSelect: function() {
        $('#soladmin-select-statements-subject').change(function(e) {
            $('#statement-ajax-container').html('<img src="/images/ajax-loader.gif" class="loader-image">');
            var url = '/soladmin/frameworks/' + $(this).data('framework') + '/' + $(this).val() + '/statements';
            $.get(url, function(data) {
                $('#statement-ajax-container').html(data);
                App.initSortable();
                //Assessment.bindKPICheckboxes();
                Admin.bindLevelAccordions();
                Admin.bindAddStatement();
                App.initCollapsible();
            });
        });

        $('#admin-select-statements-subject').change(function(e) {
            $('#statement-ajax-container').html('<img src="/images/ajax-loader.gif" class="loader-image">');
            var url = '/admin/frameworks/' + $(this).data('framework') + '/' + $(this).val() + '/statements';
            $.get(url, function(data) {
                $('#statement-ajax-container').html(data);
                App.initSortable();
                //Assessment.bindKPICheckboxes();
                Admin.bindLevelAccordions();
                Admin.bindAddStatement();
                App.initCollapsible();
            });
        });

        var matches = window.location.href.match(/frameworks\/([0-9]+)\/edit\?subject_id\=([0-9]+)/);
        if (matches && matches.length > 1) {
            $('#admin-select-statements-subject').val(matches[2]).trigger('change');
            $('#soladmin-select-statements-subject').val(matches[2]).trigger('change');
        }
    },

    bindKPICheckboxes: function() {
        $('.toggle-statement-kpi').on('change', function() {
            var id = $(this).data('statement-id');
            var frameworkId = $(this).data('framework-id');
            $.ajax({
                url: '/admin/frameworks/' + frameworkId + '/statements/' + id + '/set-kpi',
            });
        });
    },

    bindFrameworkComplexSelect: function() {
        $('#toggle-overlay').on('click', function() {
            var position = $(this).offset();
            $('#overlay').css('position', 'absolute').css('top', position.top).css('left', position.left).show();
        });
    },

    bindStarCard: function() {
        $('#starCardModal').on('shown.bs.modal', function (e) {
            var modal = $(this);
            var button = $(e.relatedTarget);
            var statementId = button.data('statement-id');
            var pupilId = button.data('pupil-id');
            var starId = button.data('star-id');
            var frameworkId = button.data('framework-id');
            var levelId = button.data('level-id');
            var subjectId = button.data('subject-id');
            var starCardId = button.data('star-card-id');
            var backFill = 0;

            var multievidence = 'no';
            if (button.data('multievidence')) {
                multievidence = button.data('multievidence');
            }

            if (typeof button.data('backfill') !== 'undefined' && button.data('backfill') === 1) {
                backFill = 1;
            }

            var url = '/assessment/star-cards/' + statementId + '/' + pupilId + '/' + starId + '/' + frameworkId + '/' + levelId + '/' + subjectId +
                '/add?backFill=' + backFill + '&multievidence=' + multievidence;

            if (starCardId != 'add') {
                url = '/assessment/star-cards/' + starCardId + '?backFill=' + backFill;
            }

            $.get(url, function(data) {
                modal.find('.modal-content').html(data);
                if (multievidence == 'no') {
                    Assessment.bindSaveStarCard();
                } else {
                    Assessment.bindCompleteStatementsWithEvidence();
                }
                /* double star card completion
                Assessment.bindCompleteStatementsWithEvidence();
                */
                Assessment.starCardEvents();
                Assessment.checkComplete();
                $('#show-moderation').attr('href', '/moderation/' + statementId + '/' + pupilId);
                App.initProfileBarButtons();
                Assessment.bindPrintStarCard();
                //Assessment.bindSendEmail();
                $('#starcard-print').attr('href', '/assessment/star-cards/' + starCardId + '/print');
                //Assessment.bindAutoBackfillModalActions();
                Assessment.bindBackfillModalActions();
                Assessment.starCardChars = modal.html().length + $('#context').val().length + $('#evidence').val().length;
            });

            // if (starCardId == 'add') {
            //     $.get('/assessment/star-cards/' + statementId + '/' + pupilId + '/' + starId + '/' + frameworkId + '/' + levelId + '/' + subjectId + '/add?backFill=' + backFill, function(data) {
            //         modal.find('.modal-content').html(data);
            //         Assessment.bindSaveStarCard();
            //         Assessment.starCardEvents();
            //         Assessment.checkComplete();
            //         $('#show-moderation').attr('href', '/moderation/' + statementId + '/' + pupilId);
            //         App.initProfileBarButtons();
            //         Assessment.bindPrintStarCard();
            //         //Assessment.bindSendEmail();
            //         $('#starcard-print').attr('href', '/assessment/star-cards/' + starCardId + '/print');
            //         Assessment.bindBackfillModalActions();
            //         Assessment.starCardChars = modal.html().length + $('#context').val().length + $('#evidence').val().length;
            //     });
            // } else {
            //
            // }
        });
    },

    changesMade: function() {
        var currentCharCount = $('#starCardModal').html().length + $('#context').val().length + $('#evidence').val().length;
        if (currentCharCount != Assessment.starCardChars ) {
            return true;
        }
        return false;
    },

    bindStarCardClose: function () {
        $('.close, button#starCardCancel').click(function(e){
            e.preventDefault();
            e.stopPropagation();
            if (Assessment.changesMade()){
                if (confirm('Are you sure you want to close without saving your changes?')) {
                    $('#starCardModal').modal('hide');
                } else {
                    // Do nothing!
                }
            } else {
                $('#starCardModal').modal('hide');
            }
        })
    },

    checkComplete: function() {
        var switchery = $('#starCardModal').find('.switchery-default');
        if ($(switchery).css('background-color') == "rgb(100, 189, 99)"){
            Assessment.editable = false;
        } else {
            Assessment.editable = true;
        }
        Assessment.toggleStarCardElements();
    },

    toggleStarCardElements: function() {
        if (Assessment.editable) {
            $('#starCardModal').find('.switchery-default').removeClass("disabled");
            $('#context').attr('readonly', false);
            $('#evidence').attr('readonly', false);
            $('#starCardSave').attr('hidden', false);
            $('#starCardModal').find('.dropzone').parent().removeClass('hidden');
            $('#starCardModal').find('.fa-remove').removeClass('hidden');
        } else {
            $('#starCardModal').find('.switchery-default').addClass("disabled");
            $('#context').attr('readonly', true);
            $('#evidence').attr('readonly', true);
            $('#starCardSave').attr('hidden', true);
            $('#starCardModal').find('.dropzone').parent().addClass('hidden');
            $('#starCardModal').find('.fa-remove').addClass('hidden');
        }
    },

    editCheck: function() {
        if (Assessment.editable) {
            Assessment.editable = false;
        } else {
            Assessment.editable = true;
        }
        Assessment.toggleStarCardElements();
    },

    bindLevelEdit: function() {
        $('.level-edit').on('click', function(e) {
            e.stopPropagation();
            var levelId = $(this).data('level');
            var pupilId = $(this).data('pupil');
            var subjectId = $(this).data('subject');
            var modal = $('#levelModal');

            $.get('/levels/' + levelId + '/edit?pupil_id=' + pupilId + '&subject_id=' + subjectId, function(data) {
                modal.find('.modal-content').html(data);
                modal.modal();
                App.initDatepicker();
                Assessment.bindBaselineSelect();
                Assessment.bindClearLevel();
            });
        });

        $('.level-evidence').on('click', function(e) {
            e.stopPropagation();
            window.location.href = $(this).attr('href');
        });
    },

    /**
     * Events bound every time a star card is loaded
     */
    starCardEvents: function() {
        App.initSwitchery();
        App.initDatepicker();
        App.initZoom();
        Assessment.bindEditStarCard();
        Assessment.bindTextFields();
        Assessment.bindClearStarCard();
        Assessment.bindHistoryStarCard();
        Assessment.bindStarCardFiles();
        Assessment.bindStarCardClose();
        Forms.bindDropzones();
    },
    bindClearStarCard: function() {
        $('.clear-star-card').on('click', function() {
            var starCardId = $(this).data('star-card');
            $.get('/assessment/star-cards/' + starCardId + '/clear', function(data) {
                $('#achieved').trigger('click');
                $('#date').val('');
                $('#star-card-files-container').html('');
                $('i[data-star-card-id="' + starCardId + '"]').removeClass('fa-star').addClass('fa-star-o');
            });
        });
    },

    bindStarCardFiles: function() {
        $('.star-card-file .fa-remove').on('click', function() {
            var file = $(this).parents('.star-card-file');
            var fileId = $(this).data('file');
            var deletedFiles = $('#deletedFiles');
            //var starCardId = $(this).data('starcard');
            if (confirm('Are you sure you want to remove this file?')) {
                // $.post('/assessment/star-cards/' + starCardId + '/remove-file?fileId=' + file.data('file-id'), function () {
                //     file.remove();
                //     $('.zoomContainer').remove();
                //     App.initZoom();
                // });
                var id = $(this).attr('id');
                $('#file-' + id + '-input').attr('disabled', true);
                $(this).parent().hide();
                if (deletedFiles.val().length <= 0) {
                    deletedFiles.val(fileId);
                } else {
                    deletedFiles.val(deletedFiles.val() + ',' + fileId);
                }
            }
        });

        $('.image-rotate').click(function() {
            var btn = $(this);
            var sign = '';
            var direction = btn.data('direction');
            var input = $('#file-' + btn.data('image') + '-input');
            var currentAngle = input.val();
            if (currentAngle == 360 || currentAngle == -360) {
                currentAngle = 0;
            }
            input.attr('disabled', false);
            if (direction == 'acw') {
                sign = '-';
            }
            var image = $('#' + btn.data('image'));
            var angle = parseInt(currentAngle) + parseInt(sign.concat(90));
            input.val(angle);
            console.log(angle);
            //var css = 'transform: rotate(' + angle + 'deg)';
            image.css('-webkit-transform', 'rotate(' + angle + 'deg)');
            image.css('-moz-transform', 'rotate(' + angle + 'deg)');
            image.css('transform', 'rotate(' + angle + 'deg)');
        });


        $('.star-card-file .fa-download').on('click', function() {
            var file = $(this).parents('.star-card-file');
            window.location.href = '/files/' + file.data('file-id') + '/download';
        });
    },

    bindPrintStarCard: function() {
        // $('.btn-print-email').click(function(){
        //     if ($('.star-card-content').is(':visible')) {
        //         $('.star-card-content').hide();
        //         $('.star-card-print').show();
        //         $(this).html('<i class="fa fa-history"></i> Star Card');
        //         $('#behat-history-star-card, .clear-star-card, #behat-history-star-card, #editStarCard').hide();
        //         $('.email-profile, .print-profile').show();
        //         //$('.history-star-card').html('<i class="fa fa-history"></i> Star Card');
        //     } else {
        //         $('.star-card-content').show();
        //         $('.star-card-print').hide();
        //         $(this).html('<i class="fa fa-print"></i> Print/Email');
        //         $('#behat-history-star-card, .clear-star-card, #behat-history-star-card, #editStarCard').show();
        //         $('.email-profile, .print-profile').hide();
        //         //$('.history-star-card').html('<i class="fa fa-history"></i> History');
        //     }
        // });
    },

    bindHistoryStarCard: function() {
        $('.history-star-card').off('click').on('click', function() {
            if ($('.star-card-content').is(':visible')) {
                $('.star-card-content').hide();
                $('.star-card-history').show();
                $('.history-star-card').html('<i class="fa fa-history"></i> Star Card');
            } else {
                $('.star-card-content').show();
                $('.star-card-history').hide();
                $('.history-star-card').html('<i class="fa fa-history"></i> History');
            }
        });

        // Load a historial star card
        $('.view-star-card').off('click').on('click', function() {
            var starCardId = $(this).data('star-card-id');
            $.get('/assessment/star-cards/' + starCardId, function(data) {
                $('#starCardModal .modal-content').html(data);
                Assessment.starCardEvents();
                $('#starCardSave').removeAttr('disabled')
            });
        });
    },

    bindTextFields: function() {
        $('#context, #evidence').on('click', function() {
            if (!Assessment.editable) {
                Assessment.editable = true;
                Assessment.toggleStarCardElements();
            }
        });
    },

    bindEditStarCard: function() {
        // TODO: When click edit, select person as me and date as today
        $('#editStarCard').on('click', function() {
            Assessment.editCheck();
            var myUser = $('#entered_user_id option[data-current]').val();
            $('#entered_user_id').val(myUser);
            //$('#date').datepicker('update', moment().format('ddd D MMMM YYYY'));
        });
    },

    bindAssessmentSelects: function() {
        $('#assessment-assessment-framework').on('change', function() {
            window.location.href = '/assessment/frameworks/' + $(this).val();
        });

        $('#assessment-subject').on('change', function() {
            window.location.href = '/assessment/' + $(this).val() + '/' + $(this).data('pupil');
        });
    },

    enableMultiSelect: function() {
        $('.star-card-mini .fa-star-o').css('z-index', 9999).draggable({
            revert: true,
            helper: 'clone',
            opacity: 1.0
        });

        // $( "#droppable" ).droppable({
        //   drop: function( event, ui ) {
        //     $( this )
        //       .addClass( "ui-state-highlight" )
        //       .find( "p" )
        //         .html( "Dropped!" );
        //   }
        // });
    },

    toggleStatementElements: function(applicable, statementId) {
        if (applicable) {
            Assessment.currentStatement.find('#statement-' + statementId + ':first').removeClass('statement-na');
            Assessment.currentStatement.find('#statement-na-' + statementId).hide();
            Assessment.currentStatement.find('.set-statement-na').show();
            Assessment.currentStatement.find('.set-statement-applicable').hide();
            Assessment.currentStatement.find('.star-na').removeClass('star-na');
        } else {
            Assessment.currentStatement.find('#statement-' + statementId + ':first').addClass('statement-na');
            Assessment.currentStatement.find('#statement-na-' + statementId).show();
            Assessment.currentStatement.find('.set-statement-na').hide();
            Assessment.currentStatement.find('.set-statement-applicable').show();
            Assessment.currentStatement.find('.fa-star-o, .fa-star').addClass('star-na');
        }
    },

    bindRestoreStatementNa: function() {
        $('.set-statement-applicable').click(function(e) {
            var statementId = $(this).data('statement-id');
            var pupilId = $(this).data('pupil-id');
            var statement = $(this).data('statement');
            //var subjectId = $(this).data('subject-id');
            $.get('/assessment/statements/' + statementId + '/' + pupilId + '/na'), function(dataNa) {

            };
            // Assessment.currentStatement = $(this).parent().parent();
            // Assessment.toggleStatementElements(true, statementId);
            location.reload();
        });
    },

    bindSetStatementNa: function() {
        $('.set-statement-na').on('click', function(e) {
            Assessment.currentStatement = $(this).parent().parent();
            var naModal = $('#naModal');
            var btn = $(this);
            var statementId = btn.data('statement-id');
            var pupilId = btn.data('pupil-id');
            var statement = btn.data('statement');
            var levelId = btn.data('level-id');
            $('#naStatementSave').attr('data-route', '/assessment/statements/' + statementId + '/' + pupilId + '/na');
            $('#na-statement').html(statement);
            naModal.modal('show');
            Assessment.bindNaSave(statementId);
        });
        Assessment.bindRestoreStatementNa();
    },

    bindNaSave: function (statementId) {
        $('#naStatementSave').click(function(){
            var saveBtn = $(this);
            var reason = $('#na-reason').val();
            if (reason !='' && reason != null && reason != undefined) {
                saveBtn.data('route', $(this).attr('data-route') + '?reason=' + reason);
                $.get(saveBtn.data('route'), function(data) {
                    Assessment.toggleStatementElements(false, statementId);
                    location.reload();
                });
            } else {
                alert("Reason can not be blank!");
            }
        })
    },

    displayDummyGraphs: function() {
        if ($('#histogram').length > 0) {
            var ctx = $('#histogram');
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "",
                            fill: false,
                            lineTension: 0.1,
                            backgroundColor: "rgba(75,192,192,0.4)",
                            borderColor: "rgba(75,192,192,1)",
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "rgba(75,192,192,1)",
                            pointBackgroundColor: "#fff",
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: "rgba(75,192,192,1)",
                            pointHoverBorderColor: "rgba(220,220,220,1)",
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: [65, 59, 80, 81, 56, 55, 40],
                        },
                        {
                            label: "",
                            fill: false,
                            lineTension: 0.1,
                            backgroundColor: "rgba(75,192,192,0.4)",
                            borderColor: "rgba(75,192,192,0.4)",
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "rgba(75,192,192,0.4)",
                            pointBackgroundColor: "#fff",
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: "rgba(75,192,192,0.4)",
                            pointHoverBorderColor: "rgba(220,220,220,0.4)",
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: [12, 24, 34, 87, 73, 12, 59],
                        }
                    ]
                },
                options: {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                display: false
                            }
                        }]
                    }
                }
            });
        }
    },

    bindGroupStarComplete: function() {
        $('.group-star-complete').on('click', function(e) {
            var starName = $(this);
            var starId = $(this).attr('data-star');
            var row = $(this).closest('tr');
            var levelId = row.data('level');
            var form = $('#form-' + levelId);
            var anchor = $('#completeStatement-' + levelId);
            var container = $('#completeStatementContainer-' + levelId);
            var datePicker = $('#datePicker-' + levelId);

            if (starName.hasClass('selected-star-name') && starName.hasClass('selected-statement')) {
                starName.removeClass('selected-star-name').removeClass('selected-star-name-' + levelId);
                starName.removeClass('selected-statement');
                if ($('.selected-star-name-' + levelId).length == 0) {
                    var action = form.attr('action');
                    action = action.replace(/\d*\/complete/, '0/complete');
                    form.attr('action', action);
                    anchor.removeAttr('data-star');
                    container.hide();
                    datePicker.addClass('hidden').removeClass('display-inline');
                }
                $('.statement-number[data-level="' + levelId + '"]').each(function(index) {
                    var statementNumber = $(this);
                    statementNumber.removeClass('selected-statement').removeClass('selected-statement-' + levelId);
                    var statementId = $(this).attr('data-statement');
                    var statementInput = $('#statement-' + statementId);
                    statementInput.prop('checked', false);
                });
                return false;
            }

            starName.addClass('selected-star-name').addClass('selected-star-name-' + levelId);
            starName.addClass('selected-statement');
            starName.siblings().removeClass('selected-statement');
            var action = form.attr('action');
            action = action.replace(/\d*\/complete/, starId + '/complete');
            form.attr('action', action);
            anchor.attr('data-star', '' + starId);
            container.show();
            datePicker.removeClass('hidden').addClass('display-inline');
            $('.statement-number[data-level="' + levelId + '"]').each(function(index) {
                var statementNumber = $(this);
                statementNumber.addClass('selected-statement').addClass('selected-statement-' + levelId);
                var statementId = $(this).attr('data-statement');
                var statementInput = $('#statement-' + statementId);
                statementInput.prop('checked', true);
            });
            // drop Add Evidence Button from group star complete
            $('.add-evidence').hide();
        });
    },

    bindLevelPdf: function() {

        $('.level-pdf').click(function(event) {
            event.stopPropagation();
        });
    },
};